<template>
  <div class="indexBannerBar" v-if="bottomBannerData.module_picture != ''">
    <van-image :src="bottomBannerData.module_picture" />
  </div>
</template>
<script>
import { Image as VanImage } from "vant";

export default {
  name: "bannerBar",
  components: { VanImage },
  props: ["bottomBannerData"],
  data() {
    return {};
  },
  methods: {},
};
</script>
<style scoped>
/* .footer {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  z-index: 10;
  background: #ffffff;
}
.footerBar {
  padding: 5px 5px 0 5px;
  height: 45px;
}
.ico_like,
.ico_share {
  display: inline-block;
  min-width: 28px;
  height: 40px;
  padding-top: 22px;
  line-height: 18px;
  background-size: 28px 28px;
  margin: 0 8px;
  cursor: pointer;
  background-repeat: no-repeat;
  background-position: center top;
  color: #979aa3;
  font-size: 11px;
  text-align: center;
}
.ico_like {
  background-image: url(../../assets/images/icon_like.png);
}
.ico_like.actived {
  background-image: url(../../assets/images/icon_likeactived.png);
}
.ico_share {
  background-image: url(../../assets/images/icon_share.png);
} */
</style>